import { render, staticRenderFns } from "./MonitoramentoDashboard.vue?vue&type=template&id=57a54953&scoped=true&lang=pug"
import script from "./MonitoramentoDashboard.vue?vue&type=script&lang=js"
export * from "./MonitoramentoDashboard.vue?vue&type=script&lang=js"
import style0 from "./MonitoramentoDashboard.vue?vue&type=style&index=0&id=57a54953&prod&lang=scss&scoped=true"
import style1 from "./MonitoramentoDashboard.vue?vue&type=style&index=1&id=57a54953&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a54953",
  null
  
)

export default component.exports